import { render, staticRenderFns } from "./pay-code.vue?vue&type=template&id=bc0ea040&scoped=true"
import script from "./pay-code.vue?vue&type=script&lang=js"
export * from "./pay-code.vue?vue&type=script&lang=js"
import style0 from "./pay-code.vue?vue&type=style&index=0&id=bc0ea040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0ea040",
  null
  
)

export default component.exports